<div class="with-tip">
  <button
    (click)="onButtonClick()"
    [class.with-tip]="tip!==null"
    class="iv-img-button"
    type="button"
  >
    <ng-content></ng-content>
  </button>
  <span *ngIf="tip!==null" class="tip">
  {{tip}}
</span>
</div>
